import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { IDecodeVinPayload, IVinDecodeResponse } from "./vinDecoder.types";

export const DECODE_VIN_PROGRESS = "DECODE_VIN_PROGRESS";
export const DECODE_VIN_SUCCESS = "DECODE_VIN_SUCCESS";
export const DECODE_VIN_FAILED = "DECODE_VIN_FAILED";

export const decodeVinProgress = () => action(DECODE_VIN_PROGRESS);
export const decodeVinSuccess = (data: IVinDecodeResponse) =>
  action(DECODE_VIN_SUCCESS, { data });
export const decodeVinFailed = (errorMessage: string) =>
  action(DECODE_VIN_FAILED, { errorMessage });

export const decodeVinAsync =
  (vin: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(decodeVinProgress());
      const payload: IDecodeVinPayload = {
        vin: vin.trim(),
        companyCode: "HM",
        language: "EN",
        status: "ACTIVE",
      };
      const res = await api.post("/ibc/decode-vin", payload);
      const data: IVinDecodeResponse = res.data.data.vinInfo;
      dispatch(decodeVinSuccess(data));
    } catch (err: any) {
      dispatch(decodeVinFailed(err.response.data.message));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };
